import { createFileRoute } from "@tanstack/react-router";
import DealeriVerificati from "@/pages/DealeriVerificati";
import { routeHead } from "@/lib/seo/route-head";
import { loadVerifiedDealers } from "@/lib/seo/verified-dealers-seo";

export const Route = createFileRoute("/dealeri-verificati/")({
  head: () => routeHead("/dealeri-verificati/"),
  loader: () => loadVerifiedDealers("RO"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DealeriVerificati />
  );
}
